<style scoped lang="scss">

</style>

<template>
  <b-navbar toggleable="md" type="light" variant="light">

    <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

    <b-navbar-brand href="#">
        <span style="color:#c22">Intri</span>
        <span style="color:#5e5e5e">VPN</span>
    </b-navbar-brand>

    <b-collapse is-nav id="nav_collapse">
      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
        <b-nav-item-dropdown right>
          <!-- Using button-content slot -->
          <template slot="button-content">
            <em>{{ user.email }}</em>
          </template>
          <b-dropdown-item href="#" @click="clickSignOut()">
            <i class="fas fa-sign-out-alt"></i>
            Signout
          </b-dropdown-item>
          <b-dropdown-item disabled style="cursor: default">
            v2.0.0
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>

    </b-collapse>
  </b-navbar>
</template>

<script>
import { mapState } from 'vuex'
import { signOut } from '@/firebaseRef'
export default {
  components: {

  },
  data () {
    return {

    }
  },
  firebase () {
    return {

    }
  },
  computed: mapState([
    'user'
  ]),
  ready () {

  },
  methods: {
    clickSignOut () {
      signOut()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Navbar.vue